<template>
  <PlatformHiuMini
    ref="platform"
    displayType="NT7538"
    :bridge="bridge"
    :localStoragePrefix="localStoragePrefix"
    :buttons="buttons"
    :outputs="outputs"
    :uarts="uarts"
    :leds="leds"
    :languages="languages"
    :vbusSpecifications="vbusSpecifications"
    :wasmUrl="wasmUrl"
    @initialized="platformInitialized"
  ></PlatformHiuMini>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformHiuMini from '@/device-platforms/PlatformHiuMini.vue';

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformHiuMini,
  },

  data: () => ({
    label: 'ResolHIUMini_2d00_P110',
    wasmUrl:'/100000178_4F5B_RHIU_Mini_2.00-P110-FL-DZ.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex: 0, conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S1', },
      { platformIndex: 1, conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S2', },
      { platformIndex: 2, conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S3', },
      { platformIndex: 3, conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', },
      { platformIndex: 4, conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', },
      { platformIndex: 5, conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S6', },
      { platformIndex: 6, conversion: 'voltageGaTemperature', value: null, initialValue: 12.3, name: 'GFA1T', }, // GFA 1
      { platformIndex: 7, conversion: 'voltageRpsPressure', value: null, initialValue: 2.3, name: 'GFA1P', }, // GFA 1
      { platformIndex: 8, conversion: 'frequencySIKA_VY1545MAHN', value: null, initialValue: 3, name: 'SIKA', },
      // { platformIndex: 8,conversion: 'frequencyPAW_FlowRotor_DN20', conversions: ['frequencyPAW_FlowRotor_DN20', 'frequencyPAW_FlowRotor_DN25'], value: null, initialValue: 0, name: 'SIKA', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, // R1 - HK-P
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, // R2 - Zirk-P
      { name: 'R3', conversion: 'dutycyclePercent', value: null }, // R3 - Anforderung
      { name: 'A', conversion: 'dutycyclePercent', value: null },  // A - Mischer (PWM1/0-10V)
      { name: 'B', conversion: 'dutycyclePercent', value: null },  // B - Ticket #14709: ZirkPumpe Drehzahl
      { name: 'B1', conversion: 'dutycyclePercent', value: null }, // PWM3 -> VRef DRV8434 -> Fingern weg, nicht anfassen !!!
      { name: 'C', conversion: 'rawDigitalPercent', value: null, factor: 104 }, // C - Durchgangsventil (COUNTER-Output) -> Stepper !
    ],

    leds: [
        { state: null }
    ],

    uarts: [
       { name: 'VBUS1', kind: 'VBus', },
       { name: 'ZA', kind: 'VBus', },
    ],

    languages: [
      { value: 0, text: 'Deutsch' },
      { value: 1, text: 'English' },
    ],
  }),

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      // const vsfResponse = await fetch('/vbus_specification.vsf');
      // const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      // const vsfBuffer = Buffer.from(vsfArrayBuffer);
      // const specificationFile = new SpecificationFile(vsfBuffer);
      // const specification = new Specification({ specificationFile });
      // this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
